import { useState } from "react";
import { hotWords } from "@/mocks/homeContent";

export default function HotWords() {
  const [active, setActive] = useState<string | null>(null);

  return (
    <section id="words" className="py-12 md:py-16">
      <div className="mx-auto grid w-full max-w-6xl grid-cols-1 items-center gap-6 px-4 md:px-6 lg:grid-cols-[auto_1fr]">
        <div>
          <h2 className="flex items-center gap-2 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
            <span className="inline-flex h-9 w-9 items-center justify-center rounded-lg bg-gradient-to-br from-accent-400 to-accent-600 text-background-50 md:h-10 md:w-10">
              <i className="ri-focus-3-fill text-lg leading-none"></i>
            </span>
            飙升热词
          </h2>
          <p className="mt-2 max-w-xs text-sm leading-6 text-foreground-600">
            短时内讨论量蹿升的关键词，点一下即可定位相关话题（演示交互）。
          </p>
        </div>

        <div className="flex flex-wrap gap-2.5">
          {hotWords.map((w) => {
            const on = active === w.word;
            return (
              <button
                key={w.word}
                onClick={() => setActive(on ? null : w.word)}
                className={`inline-flex items-center gap-2 whitespace-nowrap rounded-full border px-4 py-2 text-sm font-semibold transition-colors ${
                  on
                    ? "border-primary-500 bg-primary-500 text-background-50"
                    : "border-secondary-200 bg-background-50 text-foreground-800 hover:border-accent-300 hover:text-accent-800"
                }`}
              >
                {w.word}
                <span
                  className={`rounded px-1.5 py-0.5 text-[11px] font-bold ${
                    on ? "bg-background-50/20 text-background-50" : "bg-accent-100 text-accent-700"
                  }`}
                >
                  {w.delta}
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}